(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hflex-category-chips"] && !Shopify.designMode) return;
  try {
    /* Bring the selected category into view in the scrolling mobile row. */
  (function () {
    function reveal() {
      document.querySelectorAll('.hfx-cats--toolbar').forEach(function (row) {
        var active = row.querySelector('.is-active');
        if (!active || active === row.firstElementChild) return;
        row.scrollLeft = active.offsetLeft - row.offsetLeft - 12;
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reveal);
    else reveal();
    document.addEventListener('shopify:section:load', reveal);
  })();
  } catch(e) { console.error(e); }
})();

})();
